module.exports = __webpack_public_path__ + "static/media/Mewtwo_gaussian2.91a7635e.png";